import { Fetching } from '@innovatrics/checkin-components'
import { useNavigate, useParams } from 'react-router-dom'
import { gql } from 'urql'
import { useGetSharedLinkQuery } from '../generated/graphql'
import { AutoCaptureContainer } from '../views'

export const SharedLinkQueryContainer = () => {
  const { hash } = useParams()
  const navigate = useNavigate()

  gql`
    query GetSharedLink($hash: String!) {
      sharedLinks(where: { hash: { _eq: $hash } }) {
        ...GetSharedLinkFields
      }
    }

    fragment GetSharedLinkFields on sharedLink {
      organization {
        id
        name
        email
      }
    }
  `

  const [{ data: linkData, fetching: fetchingLinkData }] =
    useGetSharedLinkQuery({
      variables: { hash },
    })

  const hotelName = linkData?.sharedLinks?.[0]?.organization.name
  const organizationId = linkData?.sharedLinks?.[0]?.organization.id

  if (!fetchingLinkData && !hotelName && !organizationId) navigate('/404')

  return fetchingLinkData ? (
    <Fetching />
  ) : (
    <AutoCaptureContainer
      hotelName={hotelName}
      organizationId={organizationId}
    />
  )
}
